import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header/Header';
import HomeSection from './components/HomeSection/HomeSection';
import Footer from './components/Footer/Footer';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Careers from './pages/Careers';
import AboutUs from './pages/AboutUs';
import VerticalsWePower from './components/VerticalsWePower/VerticalsWePower';
import Cip from './components/CognitvaCip/Cip';
import IndiaVerdict from './components/LegalComponents/IndiaVerdict';
import './App.css';
import './Fonts/Author_Complete/Fonts/WEB/css/author.css';
import { initGA } from "./analytics";
import RouteTracker from './RouteTracker';
import FloatingButton from './components/FloatingButton/FloatingButton';
import HomePage from './pages/HomePage';
import HealthCareProducts from './pages/HealthCareProducts';
import ManufacturingProducts from './pages/ManufacturingProducts';



const App = () => {
  useEffect(() => {
    initGA();
  }, []);

  const handleFloatingClick = () => {
    window.location.href = "/contact";
    // Add your actual logic here
  };

  return (
    <Router>
      <RouteTracker />
      <Header />
      <Routes>
        <Route path="/" element={<HomeSection />} />
        <Route path="/home2" element={<HomeSection />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/terms-of-user" element={<PrivacyPolicy />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/verticals-we-power" element={<VerticalsWePower />} />
        <Route path="/cip" element={<Cip />} />
        <Route path='/legal' element={<IndiaVerdict />} />
        <Route path='/healthcare' element={<HealthCareProducts />} />
        <Route path='/manufacturing' element={<ManufacturingProducts />} />
      </Routes>
      <Footer />
      <FloatingButton onClick={handleFloatingClick} />
    </Router>
  );
};

export default App;